import React, { useState } from "react";
import logo from "../../../assets/Picture.png";
import {
  Document,
  Page,
  StyleSheet,
  Image,
  Text,
  View,
  pdf,
} from "@react-pdf/renderer";
import { FormatDate } from "../../../lib/dateFormat";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 20,
  },
  layout: {
    padding: "10px 0",
    border: "1px solid gray",
  },
  header: {
    marginBottom: 10,
    borderBottom: "1px solid gray",
    flexDirection: "row",
    justifyContent: "space-between",
    alignContent: "center",
  },
  logo: {
    width: 80,
    marginBottom: 20,
  },
  section: {
    flexDirection: "row",
    gap: 10,
    alignItems: "center",
    padding: 10,
  },

  section1: {
    flexDirection: "column",
    gap: 3,
    alignItems: "start",
    justifyContent: "start",
    padding: 10,
  },
  section2: {
    width: "50%",
    flexDirection: "column",
    padding: 10,
  },
  section3: {
    width: "50%",
    flexDirection: "column",
    padding: 10,
    borderLeft: "1px solid gray",
  },
  section4: {
    width: "100%",
    flexDirection: "column",
    padding: 10,
    borderBottom: "1px solid gray",
  },
  box: {
    flexDirection: "column",
    padding: "10px 0",
  },
  title: {
    fontSize: 10,
    marginBottom: 5,
    font: "Arial",
    textTransform: "uppercase", // Capitalize text
    // fontWeight: 'bold',
  },
  title1: {
    width: "100%",
    fontSize: 10,
    padding: "0 10px ",
    textTransform: "uppercase", // Capitalize text

    font: "Arial",
    // fontWeight: 'bold',
  },

  text: {
    fontSize: "8px",
    marginBottom: 5,
  },
  valueBox: {
    fontSize: "10px",
    marginBottom: 5,
    width: "50%",
  },
  textBox: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  rowContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 10,
    marginBottom: 10,
    borderBottom: "1px solid gray",
  },

  rowContainer1: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 10,
    marginBottom: 10,
  },

  rowBox: {
    flexDirection: "row",
    gap: 5,
    justifyContent: "space-between",
    padding: 3,
  },
  statBox: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "start",
  },
  statBox1: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "start",
    width: "23%",
  },
  statTitle: {
    color: "gray",
    fontSize: 10,
    textTransform: "uppercase", // Capitalize text
  },
  statValue: {
    fontSize: 10,
  },
  totalSection: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: "70px", // Adjust marginTop to 'auto' for automatic spacing
  },

  totalBox: {
    width: "33%",
    flexDirection: "column",
    borderBottom: "0.5px solid black",
    gap: 3,
    marginTop: 30, // Remove marginTop from here
    padding: 5,
    alignSelf: "flex-end", // Align the totalBox to the end of the container
  },
  comment: {
    width: "100%",
    padding: 10,
    fontSize: 10,
  },
});

const PDFDocument = ({ formData }) => (
  <Document>
    <Page size="A4" style={styles.page} wrap>
      {formData && (
        <View style={styles.layout}>
          <View style={styles.header}>
            <View style={styles.section}>
              <Image src={logo} style={styles.logo} />
              <View>
                <Text style={styles.title}>One union solutions</Text>
                <Text style={styles.text}>Legmeerdijk 169C</Text>
                <Text style={styles.text}>1432 KA Aalsmeer</Text>
                <Text style={styles.text}>Netherlands</Text>
              </View>
            </View>
            <View style={styles.section1}>
              <Text style={styles.text}>Tel: +31 85-0600753</Text>
              <Text style={styles.text}>Mail: operations@oneunionsolutions.com</Text>
              <Text style={styles.text}>Web: www.oneunionsolutions.com</Text>
              {/* <Text style={styles.text}>CoC: 85402478</Text>
              <Text style={styles.text}>VAT: NL863611394B01</Text> */}
            </View>
          </View>

          <Text style={styles.title1}>DELIVERY NOTE </Text>

          <View style={styles.rowContainer}>
            <View style={styles.section2}>
              <View style={styles.textBox}>
                <Text style={styles.title}>ORDER DATE: </Text>
                <Text style={styles.valueBox}>
                  {FormatDate(formData?.creationDate)}
                </Text>
              </View>

              <View style={styles.textBox}>
                <Text style={styles.title}>ORDER NUMBER: </Text>
                <Text style={styles.valueBox}>{formData?.orderNumber}</Text>
              </View>
            </View>
            <View style={styles.section2}>
              <View style={styles.textBox}>
                <Text style={styles.title}>CUSTOMER: </Text>
                <Text style={styles.valueBox}>{formData?.name}</Text>
              </View>
            </View>
          </View>

          <View style={styles.rowContainer}>
            <View style={styles.section2}>
              <View style={styles.textBox}>
                <Text style={styles.title}>PICK UP DATE: </Text>
                <Text style={styles.valueBox}>
                  {" "}
                  {FormatDate(formData?.loadAddress_PickUpDate)}
                </Text>
              </View>

              <View style={styles.textBox}>
                <Text style={styles.title}>Pickup time: </Text>
                <Text style={styles.valueBox}>
                  {" "}
                  {formData?.loadAddress_PickUpTime?.startTime} -
                  {formData?.loadAddress_PickUpTime?.endTime}
                </Text>
              </View>

              <View style={styles.textBox}>
                <Text style={styles.title}>COMPANY NAME: </Text>
                <Text style={styles.valueBox}>
                  {" "}
                  {formData?.loadAddress_CompanyName}
                </Text>
              </View>

              <View style={styles.textBox}>
                <Text style={styles.title}>CONTACT PERSON: </Text>
                <Text style={styles.valueBox}>
                  {" "}
                  {formData?.loadAddress_ContactName}
                </Text>
              </View>

              <View style={styles.box}>
                <View style={styles.textBox}>
                  <Text style={styles.title}>PHONE: </Text>
                  <Text style={styles.valueBox}>
                    {" "}
                    {formData?.loadAddress_PhoneNumber}
                  </Text>
                </View>
                <View style={styles.textBox}>
                  <Text style={styles.title}>Customer reference: </Text>
                  <Text style={styles.valueBox}>
                    {" "}
                    {formData?.loadAddress_ReferenceCustomer}
                  </Text>

                </View>




                {/* <View style={styles.textBox}>
                  <Text style={styles.title}>Delivery note No: </Text>
                  <Text style={styles.valueBox}> - </Text>
                </View> */}
                <View style={styles.textBox}>
                  <Text style={styles.title}>Comment: </Text>
                  <Text style={styles.valueBox}>
                    {" "}
                    {formData?.loadAddress_Comments}
                  </Text>
                </View>

                <View style={styles.textBox}>
                  <Text style={styles.title}>Load Address: </Text>
                  <Text style={styles.valueBox}> {formData?.loadAddress} </Text>
                </View>

                <View style={styles.textBox}>
                  <Text style={styles.title}>load Country: </Text>
                  <Text style={styles.valueBox}>
                    {" "}
                    {formData?.loadCountry}{" "}
                  </Text>
                </View>

                <View style={styles.textBox}>
                  <Text style={styles.title}>load Postal Code: </Text>
                  <Text style={styles.valueBox}>
                    {" "}
                    {formData?.loadPostalCode}{" "}
                  </Text>
                </View>
              </View>


            </View>
            <View style={styles.section3}>
              <View style={styles.textBox}>
                <Text style={styles.title}>Delivery Date: </Text>
                <Text style={styles.valueBox}>
                  {" "}
                  {FormatDate(formData?.unloadAddress_DeliveryDate)}
                </Text>
              </View>

              <View style={styles.textBox}>
                <Text style={styles.title}>Delivery time: </Text>
                <Text style={styles.valueBox}>
                  {" "}
                  {formData?.unloadAddress_DeliveryTime?.startTime} -
                  {formData?.unloadAddress_DeliveryTime?.endTime}
                </Text>
              </View>

              <View style={styles.textBox}>
                <Text style={styles.title}>Company name: </Text>
                <Text style={styles.valueBox}>
                  {" "}
                  {formData?.unloadAddress_CompanyName}
                </Text>
              </View>

              <View style={styles.textBox}>
                <Text style={styles.title}>Contact person: </Text>
                <Text style={styles.valueBox}>
                  {" "}
                  {formData?.unloadAddress_ContactName}
                </Text>
              </View>

              <View style={styles.box}>
                <View style={styles.textBox}>
                  <Text style={styles.title}>Phone: </Text>
                  <Text style={styles.valueBox}>
                    {" "}
                    {formData?.unloadAddress_PhoneNumber}
                  </Text>
                </View>
                <View style={styles.textBox}>
                  <Text style={styles.title}>Customer reference: </Text>
                  <Text style={styles.valueBox}>
                    {" "}
                    {formData?.unloadAddress_ReferenceCustomer}
                  </Text>
                </View>
                {/* <View style={styles.textBox}>
                  <Text style={styles.title}>Delivery note No: </Text>
                  <Text style={styles.valueBox}> - </Text>
                </View> */}
                <View style={styles.textBox}>
                  <Text style={styles.title}>Comment: </Text>
                  <Text style={styles.valueBox}>
                    {" "}
                    {formData?.unloadAddress_Comments}
                  </Text>
                </View>
                <View style={styles.textBox}>
                  <Text style={styles.title}>Unload Address: </Text>
                  <Text style={styles.valueBox}>
                    {" "}
                    {formData?.unloadAddress}{" "}
                  </Text>
                </View>
                <View style={styles.textBox}>
                  <Text style={styles.title}>Unload Country: </Text>
                  <Text style={styles.valueBox}>
                    {" "}
                    {formData?.unloadCountry}{" "}
                  </Text>
                </View>

                <View style={styles.textBox}>
                  <Text style={styles.title}>Unload Postal Code: </Text>
                  <Text style={styles.valueBox}>
                    {" "}
                    {formData.unloadPostalCode}{" "}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          <View style={styles.section4}>
            <Text style={styles.title}>Goods</Text>
            {formData?.pcsPackage.map((item, index) => (
              <View style={styles.rowBox}>
                <View style={styles.statBox1}>
                  {index === 0 && (
                    <Text style={styles.statTitle}>Quantity</Text>
                  )}
                  <Text style={styles.statValue}>{item?.quantity || 1}</Text>
                </View>
                <View style={styles.statBox1}>
                  {index === 0 && (
                    <Text style={styles.statTitle}>DIMENSIONS</Text>
                  )}
                  <Text style={styles.statValue}>
                    {`${item.length.value} X ${item.width.value} X ${item.height.value}`}
                  </Text>
                </View>

                <View style={styles.statBox1}>
                  {index === 0 && <Text style={styles.statTitle}>Weight</Text>}
                  <Text style={styles.statValue}>
                    {item?.weight.value ? item.weight.value : "00"}{" "}
                    {item?.weight.unit}
                  </Text>
                </View>

                <View style={styles.statBox1}>
                  {index === 0 && (
                    <Text style={styles.statTitle}>Total Weight</Text>
                  )}
                  <Text style={styles.statValue}>
                    {item.quantity * item.weight.value} {item?.weight.unit}
                  </Text>
                </View>
              </View>
            ))}
          </View>
          <View style={styles.rowContainer}>
            <View style={styles.section2}>
              <Text style={styles.title1}>
                Delivery note for receiver "{formData?.unloadAddress_CompanyName}
                "
              </Text>
            </View>
            <View style={styles.section3}>
              <View style={styles.textBox}>
                {/* <Text style={styles.title}>Delivery: </Text>
                                <Text style={styles.valueBox}> {formData.unloadAddress_DeliveryDate}</Text> */}
              </View>

              <View style={styles.box}></View>
            </View>
          </View>

          <Text style={styles.title1}>Comments</Text>

          <View style={styles.rowContainer}>
            <Text style={styles.comment}>{formData?.comments}</Text>
          </View>

          <View
            style={{ ...styles.totalSection, marginTop: "30px" }}
            wrap={false}
          >
            <View style={{ ...styles.totalBox, marginTop: 10 }}>
              <Text style={styles.title}>Signture</Text>
              <Text style={styles.text}> </Text>
            </View>
          </View>
        </View>
      )}
    </Page>
  </Document>
);
export const DelieveryNote = async (formData) => {
  const pdfBlob = await pdf(<PDFDocument formData={formData} />).toBlob();
  return pdfBlob;
};

export default DelieveryNote;
